import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

// based on view-source:https://icons.app.sbb.ch/kom/chevron-small-left-small.svg
export const ChevronSmallLeft: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <polyline fill="none" stroke={iconColor} points="13.675 8.096 9.725 12 13.673 15.904" />
    </svg>
  );
};
